import EditTask from "./EditTask";
import './App.css'
import React, { useState } from 'react';
import { Container, Form } from 'react-bootstrap';

const ToDo = ({ task, index, taskList, setTaskList }) => {
    const [isChecked, setIsChecked] = useState(false);
    const handleChange = () => {
        setIsChecked(!isChecked);
    };
    const handleDelete = () => {
        const filteredTasks = taskList.filter((_, idx) => idx !== index);
        setTaskList(filteredTasks);
        localStorage.setItem("taskList", JSON.stringify(filteredTasks));
    };

    return (
        <div className="task bg-dark-subtle d-flex  flex-row  p-5  rounded-5  w-50 ">
            <div className=" w-75 ">
                <div className="section">
                    <p className="task-Title fs-2">{task.taskName}</p>
                </div>
                <p className="task-Discription">{task.taskDiscription}</p>
                <div className="DeleteButton d-flex ">
                    <button className=" p-2    rounded-1  text-white  bg-danger" onClick={handleDelete}>Delete</button>
                    <EditTask taskList={taskList} setTaskList={setTaskList} task={task} index={index} />
                </div>
            </div>
            <div className=" w-25  ">
                <Container>
                    <Form>
                        <Form.Check
                            type="checkbox"
                            label="completed"
                            onChange={handleChange}
                            className={isChecked ? ' text-success' : ''}
                        />
                    </Form>
                </Container>
            </div>
        </div >
    )
}
export default ToDo;
